import { GatewayStatus } from 'constants/gatewayStatuses';

import { GatewayCreateFormValues } from 'pages/Gateways/GatewaysCreate/types';
import { getId } from 'utils';

export const prepareGatewayCreateSubmitValues = ({
  status,
  deactivationReason,
  attemptIntervalConfig,
  ...values
}: GatewayCreateFormValues) => ({
  ...values,
  status,
  deactivationReason: getId(status) === GatewayStatus.Disabled ? deactivationReason : null,
  attemptIntervalConfig: attemptIntervalConfig?.split(', ').map(Number),
});
